import { useQuery } from "@tanstack/react-query";
import { EffectivenessAndEfficiencyData } from "@app/overviews/network-benchmarking-dashboard/tiles/shared";
import { NetworkComparisonFiltersPayload } from "@app/overviews/network-benchmarking-dashboard/filters/network-comparison-filters/shared/NetworkComparisonFiltersPayload";
import { BenchmarkingServiceType } from "@app/overviews/network-benchmarking-dashboard/filters/shared/utility";

export interface EffectivenessAndEfficiencyDataResult {
  effectivenessAndEfficiencyData: EffectivenessAndEfficiencyData[];
  effectivenessAndEfficiencyDataLoading: boolean;
}

export const EFFECTIVENESS_AND_EFFICIENCY_DATA_QUERY_KEY_PREFIX = "benchmarking-effectiveness-and-efficiency-data";

export const useEffectivenessAndEfficiencyData = (
  service: BenchmarkingServiceType,
  payload: NetworkComparisonFiltersPayload | null
): EffectivenessAndEfficiencyDataResult => {
  const queryResult = useQuery<EffectivenessAndEfficiencyData[]>({
    enabled: !!payload,
    queryFn: ({ signal }) => service.getEffectivenessAndEfficiencyData(payload, signal),
    queryKey: [EFFECTIVENESS_AND_EFFICIENCY_DATA_QUERY_KEY_PREFIX, service?.lineOfBusiness, JSON.stringify(payload)],
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });

  return {
    effectivenessAndEfficiencyData: queryResult.data ?? [],
    effectivenessAndEfficiencyDataLoading: queryResult.isFetching,
  };
}

export default useEffectivenessAndEfficiencyData;
